export type PalletDraft = {
  cargonizerPieceNumber: string;
  weightKg: string;
  lengthCm: string;
  widthCm: string;
  heightCm: string;
  /** Identical packages this row stands for; returns only. Blank means 1. */
  copies?: string;
};

export const EMPTY_PALLET: PalletDraft = {
  cargonizerPieceNumber: '',
  weightKg: '',
  lengthCm: '',
  widthCm: '',
  heightCm: '',
};

export interface PalletMeasurements {
  weightKg: number;
  lengthCm: number;
  widthCm: number;
  heightCm: number;
}

/** A form value as a number; blank or not a number reads as 0 ("not given"). */
export function toMeasurementValue(value: string | undefined): number {
  return Number(value) || 0;
}

/** A package row's weight and dimensions as numbers. */
export function palletMeasurements(pallet: PalletDraft): PalletMeasurements {
  return {
    weightKg: toMeasurementValue(pallet.weightKg),
    lengthCm: toMeasurementValue(pallet.lengthCm),
    widthCm: toMeasurementValue(pallet.widthCm),
    heightCm: toMeasurementValue(pallet.heightCm),
  };
}

/** Length and width of a standard EUR pallet, the usual outbound package. */
export const EUR_PALLET = { lengthCm: '120', widthCm: '80' } as const;

/**
 * Any side longer than this is almost certainly millimetres typed into a
 * centimetre field (e.g. 1200 × 800 for a EUR pallet).
 */
export const MAX_PLAUSIBLE_SIDE_CM = 300;

/** The row's sides, by name, that are longer than MAX_PLAUSIBLE_SIDE_CM. */
export function implausibleSides(pallet: PalletDraft): string[] {
  const { lengthCm, widthCm, heightCm } = palletMeasurements(pallet);
  const sides: [string, number][] = [
    ['length', lengthCm],
    ['width', widthCm],
    ['height', heightCm],
  ];
  return sides.filter(([, value]) => value > MAX_PLAUSIBLE_SIDE_CM).map(([name]) => name);
}
